const Header = () => {
    return (
        <header className="container app-header">
            <h4 className="p-2 display-6">Nicotine Shot Calculator</h4>
        </header>
    )
}

export default Header